import { render, staticRenderFns } from "./SalesOriginIndicator.vue?vue&type=template&id=32de7e33&scoped=true"
import script from "./SalesOriginIndicator.vue?vue&type=script&lang=js"
export * from "./SalesOriginIndicator.vue?vue&type=script&lang=js"
import style0 from "./SalesOriginIndicator.vue?vue&type=style&index=0&id=32de7e33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de7e33",
  null
  
)

export default component.exports